import { CSSObject, SerializedStyles } from '@emotion/react'

/**
 * A helper to append style overrides to an existing list of
 * style overrides. This allows the former overrides to be
 * of any type.
 *
 * @example
 * const ComponentB = ({ styleOverrides }: WithStyleOverrides) =>
 *  <ComponentA styleOverrides={[styles.color, ...appendStyleOverrides(styleOverrides)]} />
 * }
 */
export const appendStyleOverrides = (
  styles?:
    | CSSObject
    | (CSSObject | SerializedStyles | undefined)[]
    | SerializedStyles
): Array<CSSObject | SerializedStyles> => {
  if (!styles) {
    return []
  }

  return Array.isArray(styles)
    ? (styles.filter((v) => v !== undefined) as Array<
        CSSObject | SerializedStyles
      >)
    : [styles]
}
